import React from 'react';
import { Modal, Button } from 'antd';

export default function OrderDispatchConfirmModal({
  open,
  onCancel,
  onConfirmYes,
  onConfirmNo,
  order,
  loading,
}) {
  return (
    <Modal
      title="Dispatch order"
      open={!!open}
      onCancel={onCancel}
      footer={[
        <Button
          key="yes"
          type="primary"
          onClick={onConfirmYes}
          loading={loading}
          className="app-btn-primary"
        >
          हाँ, डिस्पैच
        </Button>,
        <Button
          key="no"
          onClick={onConfirmNo}
          loading={loading}
          className="app-btn-cancel"
        >
          नहीं
        </Button>,
      ]}
      destroyOnClose
    >
      {order && (
        <>
          क्या आप इस ऑर्डर को डिस्पैच के लिए भेजना चाहते हैं?
          {order.orderNumber && (
            <> (Order <strong>{order.orderNumber}</strong>)</>
          )}
        </>
      )}
    </Modal>
  );
}
